import { request } from "utils/api";
import { UserProfile } from "api/user";
import { Club } from "api/clubs";

// owner-level settings from GET /owner/clubs
export interface OwnerClubSettings {
    lastPublicityChange: string,
    memberTaxRate: number,
    stripeAccountId?: string,
    taxNumber?: string,
    taxRate: number,
}

// fetch settings (GET /owner/clubs)
export const getSettings = (data: {
    clubId: string,
}) => request<OwnerClubSettings>({
    data,
    endpoint: "/owner/clubs",
    method: "get",
});

// save settings (PATCH /owner/clubs)
export const patchSettings = (data: {
    clubId: string,
    memberTaxRate?: number,
    taxNumber?: string,
    taxRate?: number,
}) => request<OwnerClubSettings>({
    data,
    endpoint: "/owner/clubs",
    method: "patch",
});

// archive club (DELETE /owner/clubs)
export const deleteClub = (data: {
    clubId: string,
}) => request<{}>({
    data,
    endpoint: "/owner/clubs",
    method: "delete",
});

// change club visibility (PATCH /owner/publicity)
export const patchPublicity = (data: {
    clubId: string,
    isPublic: boolean,
}) => request<Club>({
    data,
    endpoint: "/owner/publicity",
    method: "patch",
});

// transfer ownership (PATCH /owner/transfer-ownership)
export const patchTransferOwnership = (data: {
    clubId: string,
    userId: string,
}) => request<UserProfile>({
    data,
    endpoint: "/owner/transfer-ownership",
    method: "patch",
});

// sign contracts (PATCH /owner/sign-contracts)
export const patchSignContracts = (data: {
    clubId: string,
}) => request<Club>({
    data,
    endpoint: "/owner/sign-contracts",
    method: "patch",
});

// end demo mode (PATCH /owner/end-demo-mode)
export const patchEndDemoMode = (data: {
    clubId: string,
}) => request<Club>({
    data,
    endpoint: "/owner/end-demo-mode",
    method: "patch",
});

// extend demo mode (PATCH /owner/extend-demo-mode)
export const patchExtendDemoMode = (data: {
    clubId: string,
}) => request<Club>({
    data,
    endpoint: "/owner/extend-demo-mode",
    method: "patch",
});

// fetch details for owner signup (GET /root/clubs/from-signup)
export const getClubForSignup = (data: {
    signupToken: string,
}) => request<Club>({
    data,
    endpoint: "/root/clubs/from-signup",
    method: "get",
});

// sign up owner for club (POST /root/clubs/owner-signup)
export const postClubOwnerSignup = (data: {
    addresseeName: string,
    city: string,
    clubKey: string,
    clubName: string,
    country: string,
    isPublic: boolean,
    latitude: number,
    longitude: number,
    mainSportForm: string,
    postalCode: string,
    shortName: string,
    signupToken: string,
    stateOrProvince: string,
    street: string,
    timeZone: string,
}) => request<Club>({
    data,
    endpoint: "/root/clubs/owner-signup",
    method: "post",
});

// request identity verification (GET /owner/identity-verification)
export const getIdentityVerification = (data: {
    clubId: string,
    returnUrl: string,
}) => request<{ redirectUrl: string }>({
    data,
    endpoint: "/owner/identity-verification",
    method: "get",
});
